// stores/storeClientGroup.js
import { defineStore } from 'pinia'

export const useStoreClientGroup = defineStore('storeClientGroup', {
    state: () => {
        return {
            clientGroup: ''
        }
    },
    // could also be defined as
    // state: () => ({ fundSelection: [] })
    actions: {
        saveClientGroup(newClientGroup) {
            this.clientGroup = newClientGroup;
        },
    },
    getters: {
        getClientGroup: (state) => {
            return () => {
                return state.clientGroup
            }
        },
    },
    persist: true,
})
